import { Component, OnInit } from '@angular/core';
import { LoginApiService } from './features/login/services/login-api.service';
import { ToasterService } from './shared/services/toaster.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  {
 
  title = 'pbm_project';



}
